import React, {useState, Fragment ,useEffect} from "react";
import { Auth, Hub } from "aws-amplify";
import Loading from "../Components/loading";
import { accessGranted } from "../Store/loginRedux/actions";
import { useDispatch, useSelector } from "react-redux";
import ModalContainer from "../Components/modal";
import {groupsEpi} from  '../Utils/constants';
import Home from "./Home";
import {storage} from '../Utils/storage'
// import {validateUSer} from '../Utils/onlyProductAccess';
import useNavigate from '../customHook/useNavigate';
import { dataVidaPiloto } from "./asesorRg";
import ModalMaintenence from "../Components/modalMaintenence";
import { API } from "aws-amplify";

const Federate = () => {
  const [loading, setLoading] = useState(false);
  const [showModal  , setShowModal] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const granted = useSelector(
    state => state.login.granted
  );

  const channelCode = useSelector(
    state => state.login.channel
  );

  const moduleDefault = useSelector((state) => (state.login.access_configuration && state.login.access_configuration.moduleDefault));

  const dispatch = useDispatch();

  useNavigate({granted,channelCode, moduleDefault});
  

  useEffect(() => {
    Hub.listen("auth", listenerAuth);
  }, []);

  const listenerAuth = ({ payload: { event, data } }) => {
    switch (event) {
      case "signIn":
        getAuth();
        break;
      case "signOut":
        break;
    }
  };

  const getPerfilUser = async () => {
    const payload = {
      action: "getRolUser",
    };
    const response = await API.post("api-rentas", "/adviser-validate", {
      body: payload,
      headers: {}
    });
    console.log('getPerfilUser response',response)
    const { roleUser } = response.data;
    return roleUser;
  }

  const getAuth = async () => {
    setLoading(true)
    Auth.currentAuthenticatedUser()
      .then(async res => {
        const { idToken = {} } = res['signInUserSession'];
        const { given_name, email, middle_name } = idToken.payload;
        let groups = idToken.payload['cognito:groups']
        storage().setItem('jwt', idToken.jwtToken);
        if (groups) {
          const perfilUser = await getPerfilUser();
          if (perfilUser) {
            let firstName = given_name
            let username = `${given_name} ${middle_name}`;
            let idClient = email;

            //guaradar en redux el perfil del usuario
            const { channel, ...access_configuration } = perfilUser;
            dispatch(accessGranted({ username, idClient, access_configuration, channel, first: firstName }))
          } else {
            setShowModal(true)
          }
        } else {
          setShowModal(true)
        }
        
        setLoading(false)
      
      })
      .catch(e => {
          setLoading(false) 
      });
  };
  

  return (
    <Fragment>
      <Home/>
      {loading && <Loading />}
      <ModalContainer
          title={groupsEpi.title}
          open={showModal}
          login={true}
          message={groupsEpi.message_rol_invalidate}
          close={() => setShowModal(false)}
        />
      <ModalMaintenence openModal={openModal} setOpenModal={setOpenModal}/>
    </Fragment>
  );
};

export default Federate;
